const getGuideItemProducts = (guideItem) =>
  [guideItem?.actions?.subscribe?.product, guideItem?.actions?.subscribe?.productSecondary].filter(
    Boolean,
  );

export default getGuideItemProducts;
